const MODULES = {
    impactMeten: {
        slug: 'impactMeten',
        name: 'Impact meten',
        price: 65,
        stripePriceId: process.env.REACT_APP_STRIPE_PRICE_IMPACT_METEN || 'price_1OUSvbHC679HRyLi1eLKwoTX',
    },
    personas: {
        slug: 'personas',
        name: 'Deelnemer volgmodule',
        price: 30,
        stripePriceId: process.env.REACT_APP_STRIPE_PRICE_PERSONAS || 'price_1TTNipHC679HRyLitk8IdRil',
    },
    housevisits: {
        slug: 'housevisits',
        name: 'FIXtool',
        price: 34,
        stripePriceId: process.env.REACT_APP_STRIPE_PRICE_HOUSEVISITS || 'price_1TTNjMHC679HRyLifbMO65H0',
    },
    portfolio: {
        slug: 'portfolio',
        name: 'Portfolio',
        price: 30,
        stripePriceId: process.env.REACT_APP_STRIPE_PRICE_PORTFOLIO || 'price_1TTNjuHC679HRyLi3SPdmRq2',
    },
}

const PARTNER_PACKAGES = {
    tosss: {
        slug: 'tosss',
        name: 'TOSS-pakket',
        fixedPackage: {
            modules: ['impactMeten', 'personas'],
            price: 65,
            stripePriceId: process.env.REACT_APP_STRIPE_PRICE_TOSS_PACKAGE || 'price_1TTNphHC679HRyLiDL5gLCa4',
        },
        freeIncludedModules: [],
    },
    fixtool: {
        slug: 'fixtool',
        name: 'FIX (FIXbrigade)',
        fixedPackage: {
            modules: ['housevisits'],
            price: 34,
            // Pakket-prijs los van losse housevisits-tarief — fallback chain
            // valt terug op REACT_APP_STRIPE_PRICE_HOUSEVISITS voor back-compat.
            stripePriceId: process.env.REACT_APP_STRIPE_PRICE_FIX_PACKAGE
                || process.env.REACT_APP_STRIPE_PRICE_HOUSEVISITS
                || 'price_1TTNjMHC679HRyLifbMO65H0',
        },
        // Tier-upgrades: exacte-match combo's die in plaats van losse line items
        // (fixedPackage + extras) één Stripe-product gebruiken. Live "FIXtool +
        // impactmeten" combo à €99 = price_1TTNwPHC679HRyLiPYPsALrI; test-mode
        // hergebruikt het standalone-FIXtool-product via REACT_APP_STRIPE_PRICE_FIX_PLUS_IMPACT.
        packages: [
            {
                modules: ['housevisits', 'impactMeten'],
                price: 99,
                stripePriceId: process.env.REACT_APP_STRIPE_PRICE_FIX_PLUS_IMPACT || 'price_1TTNwPHC679HRyLiPYPsALrI',
            },
        ],
        freeIncludedModules: ['personas'],   // personas gratis bij FIX
    },
}

export { PARTNER_PACKAGES }
export default MODULES
